module.exports = require("lodash/get");


//////////////////
// WEBPACK FOOTER
// external "lodash/get"
// module id = 17
// module chunks = 0